<template>
    <div>
        <Header></Header>
        <div>
            <div class="card-block">
                <h1>Рассылка пользователям<router-link class="button _free _second" to="/users">К списку</router-link></h1>
                <form class="card">
                    <div class="inline">
                        <div class="grid">
                            <h3>Выбор адресата:</h3>
                            <div class="form-item radio">
                                <div class="radio-item" v-for="(item, key) in data.options" :key="key">
                                    <div>
                                        <input type="radio" :id="'choose_recipients_' + (key + 1)" v-model="data.recipients_type" v-bind:value="key + 1" />
                                        <label :for="'choose_recipients_' + (key + 1)">{{ item }}</label>
                                    </div>
                                    <div class="inline datepicker" v-if="4 == key" v-show="showDatePicker">
                                        <span>с </span>
                                        <DatePicker :value.sync="data.date_start"></DatePicker>
                                        <span>по </span>
                                        <DatePicker :value.sync="data.date_end"></DatePicker>
                                    </div>
                                </div>
                            </div>
                            <div class="form-item" v-show="showUserPicker">
                                <label for="users-search">Поиск по имени/фамилии/e-mail:</label>
                                <input id="users-search" v-model="data.search_recipient" type="text">
                                <div class="button _free" @click="searchUsers">Искать</div>
                                <div class="suggestion-list">
                                    <div class="inline" valign="center" v-show="status == 'loading'">
                                        <img src="~@/assets/img/preloader.svg" class="preloader"> Загрузка
                                    </div>
                                    <div v-for="(item, key) in data.foundUsers" :key="key">
                                        <span class="suggestion-line">
                                            {{ (item.firstname || '') + ' ' + (item.lastname || '') + ' ' }}
                                            [ <a class="strong">{{item.email}}</a> ]
                                        </span>
                                        <div class="button _free _second _tiny" :data-email="item.email" @click="addRecipient($event)">
                                            Добавить
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h3>Сообщение:</h3>
                            <div class="form-item" v-show="showUserPicker">
                                <label>Список адресатов:</label>
                                <div class="multiple-select">
                                    <label v-for="(user, key) in data.selected" :for="'recipient_' + key" :key="key" :value="user.email">
                                        <input :id="'recipient_' + key" type="checkbox" v-model="data.checked" v-bind:value="user" checked="checked"/>
                                        <span>
                                            {{ 
                                                (user.firstname || '') + ' ' 
                                                + (user.lastname || '') + ' '
                                                + '[ ' + user.email + ' ]' 
                                            }}
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="form-item">
                                <label for="orgname">Заголовок письма</label>
                                <input type="text" id="mailsubject" class="text-input _uwide" v-model="data.mail.subject" />
                            </div>
                            <div class="form-item">
                                <label for="mailbody">Текст</label>
                                <textarea id="mailbody" class="_uwide _tall" v-model="data.mail.body"></textarea>
                            </div>
                            <h3 v-if="data.preview">Предпросмотр тела письма:</h3>
                            <div v-if="data.preview" class="form-item bordered" v-html="data.preview"></div>
                        </div>
                    </div>
                </form>
                <div class="submit button _free _second" v-show="showButton" @click="preview()">Предпросмотр</div>
                <div class="submit button _free _accept" v-show="showButton" @click="send()">Отправить</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import DatePicker from '@/components/DatePicker.vue'
    
    export default {
        components: {
            Header,
            DatePicker
        },
        data () {
            return {
                status: '',
                data: {
                    preview: '',
                    options: [
                        "Все пользователи",
                        "Владельцы парковок",
                        "Администраторы парковок",
                        "Водители",
                        "Сделавшие хотя бы 1 букинг",
                        "Свой список"
                    ],
                    recipients_type: 0,
                    recipients_type_text: [
                        'all',
                        'owner',
                        'assistant',
                        'driver',
                        'driver_booked',
                        'custom'
                    ],
                    date_start: '',
                    date_end: '',
                    search_recipient: '',
                    mail: {
                        subject: '',
                        body: '{{ firstName }} {{ lastName }}'
                    },
                    users: [],
                    foundUsers: [],
                    selected: [],
                    checked: []
                }
            }
        },
        computed: {
            showDatePicker(){
                return 5 == this.data.recipients_type
            },
            showUserPicker(){
                return 6 == this.data.recipients_type
            },
            showButton () {
                if(
                    1 > this.data.recipients_type 
                    || 6 < this.data.recipients_type 
                    || '' == this.data.mail.subject 
                    || '' == this.data.mail.body
                ){
                    return false
                }
                if(5 == this.data.recipients_type && ('' == this.data.date_start || '' == this.data.date_end)){
                    return false
                }
                if(6 == this.data.recipients_type && 0 == this.data.checked.length){
                    return false
                }
                return true
            }
        },
        methods: {
            showError(text){
                let msg = {
                    message: text,
                    status: 'error'
                }
                this.$store.dispatch('utils/showMessage', msg)
            },
            searchUsers(){
                let text = this.data.search_recipient;
                this.data.foundUsers = []
                
                return new Promise((resolve, reject) => {
                    this.status = 'loading'
                    this.axios.get('api/admin/v2/user/search?text=' + text).then((resp) => {
                        this.status = ''
                        this.data.foundUsers = resp.data.response
                        resolve()
                    }).catch(() => {
                        this.status = ''
                        let msg = {
                            message: 'Ошибка при поиске пользователей',
                            status: 'error'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        reject()
                    })
                })
            },
            addRecipient(event){
                var email = '';
                
                if(event && event.target.hasAttribute('data-email')){
                    email = event.target.getAttribute('data-email')
                }
                if(!email.includes('@')){
                    this.showError('Указанная почта не валидна')
                    
                    return
                }
                
                for(var i = 0; i < this.data.users.length; ++i){
                    if(email == this.data.users[i].email){
                        for(var j = 0; j < this.data.selected.length; ++j){
                            if(this.data.selected[j].id == this.data.users[i].id){
                                this.showError('Данный пользователь уже в списке')
                                
                                return
                            }
                        }
                        
                        this.data.selected.push(this.data.users[i])
                        this.data.checked.push(this.data.users[i])
                        
                        return
                    }
                }
                
                this.showError('Указанная почта не найдена')
            },
            preview(){
                let json = JSON.stringify({
                    body: this.data.mail.body
                })

                return new Promise((resolve, reject) => {
                    this.status = 'loading'
                    this.axios.post('api/admin/v2/mass_mail/preview', json, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }).then((resp) => {
                        this.status = ''
                        this.data.preview = resp.data.response.template
                        resolve()
                    }).catch(() => {
                        this.status = ''
                        let msg = {
                            message: 'Ошибка при создании предпросмотра',
                            status: 'error'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        reject()
                    })
                })
            },
            send(){
                let json = JSON.stringify({
                    recipient_type: this.data.recipients_type_text[this.data.recipients_type - 1], 
                    subject: this.data.mail.subject,
                    body: this.data.mail.body,
                    dateStart: this.data.date_start,
                    dateEnd: this.data.date_end,
                    users: this.data.checked.map(function(user){return user.id.value}), 
                })
                return new Promise((resolve, reject) => {
                    this.status = 'loading'
                    this.axios.post('api/admin/v2/mass_mail/send', json, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }).then(() => {
                        this.status = ''
                        this.data.recipients_type = 0
                        let msg = {
                            message: 'Сообщения отправлены',
                            status: 'success'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        resolve()
                    }).catch(() => {
                        this.status = ''
                        let msg = {
                            message: 'Ошибка при отправке сообщений',
                            status: 'error'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        reject()
                    })
                })
            },
            getData(date_from = false, date_to = false) {
                return new Promise((resolve, reject) => {
                    this.status = 'loading'
            
                    var params = ''
                    if (date_from && date_to) {
                        params += '?date_from=' + date_from + '&date_to=' + date_to
                    }
            
                    this.axios.get('api/admin/v2/users' + params)
                        .then(resp => {
                            this.data.users = resp.data.response.data.filter(item => item.email)
                            this.status = ''
                            
                            resolve()
                        })
                        .catch(() => {
                            this.$router.push('/users')
                            reject()
                        })
                })
            },
        },
        created () {
            this.getData()
        }
    }
</script>